import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { Story } from './components/Story';
import { BeforeAfter } from './components/BeforeAfter';
import { PainPoints } from './components/PainPoints';
import { ClarityQuestions } from './components/ClarityQuestions';
import { Volumes } from './components/Volumes';
import { Tools } from './components/Tools';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { About } from './components/About';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-canvas font-sans text-ink" data-id="element-0" data-mp="23v2sl1d6kx4c">
      <MetaPixel data-id="element-1" data-mp="3ijfu9xduvsdk" />
      <Hero data-id="element-2" data-mp="3ihv0wb3a2fha" />
      <main data-id="element-3" data-mp="3mlj9mx3nbh44">
        <Story data-id="element-4" data-mp="3mlax56bfqdtg" />
        <BeforeAfter data-id="element-5" data-mp="3mkrbpfmkt7ao" />
        <PainPoints data-id="element-6" data-mp="3mk83iqmq9x9u" />
        <ClarityQuestions data-id="element-7" data-mp="3mjg9hk8s47lo" />
        <Volumes data-id="element-8" data-mp="3rcj6618urx63" />
        <Tools data-id="element-9" data-mp="3rbzn2h7gv2qh" />
        <Bonuses data-id="element-10" data-mp="3rdatkosaqola" />
        <Pricing data-id="element-11" data-mp="3rcsulke91w9o" />
        <Guarantee data-id="element-12" data-mp="3recbnd7qcbci" />
        <Testimonials data-id="element-13" data-mp="5osn3wyp084" />
        <About data-id="element-14" data-mp="6817u0q2c9h" />
        <Faq data-id="element-15" data-mp="4n5i12o8na1" />
        <FinalCta data-id="element-16" data-mp="5gbgztt38r4" />
      </main>
      <Footer data-id="element-17" data-mp="2zl3alhpbj03q" />
      <FloatingCta data-id="element-18" data-mp="2zld43f9knpe6" />
      <PurchasePopup data-id="element-19" data-mp="2zm4yimrfnh2v" />
    </div>;
}